export default __webpack_public_path__ + "img/spotlightStar.16045a0f.svg";